import { SaleOrderReportDto } from '@gtpl/shared-models/sale-management';
import { Injectable } from '@nestjs/common';
@Injectable()
export class SoReportAdapter {
    public convertEntityToDto(sodata: SaleOrderReportDto): SaleOrderReportDto {
        const so_data= new SaleOrderReportDto;
        so_data.soProcessType=sodata.soProcessType;
        so_data.soType=sodata.soType;
        so_data.isSubContract= sodata.isSubContract;
        so_data.soNo= so_data.soNo;
        so_data.end_customer_id= sodata.end_customer_id;
        so_data.sale_order_id= sodata.sale_order_id;
        so_data.sale_order_item_id= sodata.sale_order_item_id;
        so_data.customer= sodata.customer;
        so_data.endCustomer= sodata.endCustomer;
        so_data.poNo= sodata.poNo;
        so_data.buyerPoNo= sodata.buyerPoNo;
        so_data.cusAddress= sodata.cusAddress;
        so_data.delAddress= sodata.delAddress;
        so_data.portOfEntry= sodata.portOfEntry;
        so_data.country= sodata.country;
        so_data.destinationAddress= sodata.destinationAddress;
        so_data.etd= sodata.etd;
        so_data.eta= sodata.eta;
        so_data.delTerm= sodata.delTerm;
        so_data.payTerm= sodata.payTerm;
        so_data.shipmentTerm= sodata.shipmentTerm;
        so_data.brand= sodata.brand;
        so_data.Grade= sodata.Grade;
        so_data.variety= sodata.variety;
        so_data.productSku= sodata.productSku;
        so_data.manUnit= sodata.manUnit;
        so_data.soakStyle= sodata.soakStyle;
        so_data.soakTime= sodata.soakTime;
        so_data.jobCases= sodata.jobCases;
        so_data.cases= sodata.cases;
        so_data.packStyle= sodata.packStyle;
        so_data.brandType= sodata.brandType;
        so_data.isBrandApproved= sodata.isBrandApproved;
        so_data.addNote= sodata.addNote;
        so_data.certification= sodata.certification;
        so_data.certification_id= sodata.certification_id;
        so_data.isCertified= sodata.isCertified;
        so_data.rating= sodata.rating;
        so_data.lotCode= sodata.lotCode;
        so_data.labInspection= sodata.labInspection;
        so_data.loadInspection= sodata.loadInspection;
        so_data.processingUnit= sodata.processingUnit;
        so_data.pouches= sodata.pouches;
        so_data.pouchWeight= sodata.pouchWeight;
        so_data.uomId= sodata.uomId;
        so_data.netWeight= sodata.netWeight;
        so_data.netAmount= sodata.netAmount;
        so_data.unitPrice= sodata.unitPrice;
        so_data.currencyId= sodata.currencyId;
        so_data.soStatus= sodata.soStatus;
        so_data.invDate= sodata.invDate;
        so_data.caseWeight= sodata.caseWeight;
        so_data.styleWeighment= sodata.styleWeighment;
        so_data.factoryId= sodata.factoryId;
        so_data.processing_unit= sodata.processing_unit;
        so_data.shrimpWeight= sodata.shrimpWeight;
        so_data.category= sodata.category;
        so_data.jobType= sodata.jobType;
        so_data.createdDate= sodata.createdDate;
        so_data.reportingCases= sodata.reportingCases;
        so_data.unit_code_id= sodata.unit_code_id;
        so_data.inspection= sodata.inspection;
        so_data.sgsInspection= sodata.sgsInspection;
        so_data.tuvInspection= sodata.tuvInspection;
        so_data.productionCompleted= sodata.productionCompleted;
        so_data.productionCompletedDate= sodata.productionCompletedDate;
        so_data.completionPercentage= sodata.completionPercentage;
        so_data.containerStatus= sodata.containerStatus;
        so_data.inspectionStatus= sodata.inspectionStatus;
        so_data.cartons= sodata.cartons;
        so_data.pouchStatus=sodata.pouchStatus;
        so_data.cartonStatus= sodata.cartonStatus;
       return so_data;
      }
}